
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Shadow03:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.0481138 110.797C3.32726 128.331 40.9113 113.702 70.6443 117.874C106.999 122.997 128.25 118.085 127.998 111.378C127.241 90.3064 99.2737 103.615 69.7615 93.5279C18.8401 76.2057 -1.1185 104.565 0.0481138 110.797Z" fill="#0C0D0D"/>
</svg>

  }
  
